import styled from 'styled-components';
import TimerIconSvg from '../assets/hotels/details/timerIcon.svg';

const TimerIcon = styled(TimerIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.5rem'};
  height: ${props => props.height || '2.5rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.blue};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default TimerIcon;
